/**
 * Open Graph and Twitter Card metadata per route.
 * Used by OpenGraphHead for static routes.
 */
export interface OgMeta {
  title: string;
  description: string;
}

export const OG_META: Record<string, OgMeta> = {
  '/': {
    title: 'Alert1 Medical Alert Systems - 24/7 Emergency Response for Seniors',
    description: 'Alert1 - Medical Alert Systems for Seniors. 24/7 Emergency Response, Fall Detection, GPS Tracking. No Long-Term Contracts.',
  },
  '/pricing': {
    title: 'Low Cost Medical Alert Systems - Alert1',
    description: 'Compare Alert1 medical alert systems. Low cost, high value. No equipment fees, free activation, free shipping. No long-term contract required; cancel any time by returning equipment.',
  },
  '/medical-alerts': {
    title: 'Medical Alert Systems - Call for Lowest Price - Alert1',
    description: 'Medical alert systems for seniors. 24/7 emergency response, fall detection, GPS tracking. Call for our lowest price guarantee.',
  },
  '/how-it-works': {
    title: 'How Alert1 Medical Alert Systems Work',
    description: 'Learn how Alert1 medical alert systems connect you to 24/7 emergency help. Push a button, connect to our Command Center within seconds.',
  },
  '/blog': {
    title: 'Alert1 Medical Alert News',
    description: 'News, tips, and resources about medical alert systems, senior safety, and aging in place from Alert1.',
  },
  '/faq': {
    title: 'Medical Alert Help - FAQ - Alert1',
    description: 'Frequently asked questions about Alert1 medical alert systems, billing, equipment, and support.',
  },
  '/contact': {
    title: 'Contact Alert1',
    description: 'Contact Alert1 for questions about medical alert systems, orders, or support. Call 1-877-579-9862.',
  },
  '/terms': {
    title: 'Terms and Conditions - Alert1',
    description: 'Alert1.com website terms and conditions of use.',
  },
  '/privacy': {
    title: 'Privacy Policy - Alert1',
    description: 'Alert1 privacy policy. How we collect, use, and protect your information.',
  },
  '/our-story': {
    title: 'Our Story - Alert1',
    description: 'Learn about Alert1, our mission, and our commitment to senior safety.',
  },
  '/help': {
    title: 'How Can We Help You? - Alert1',
    description: 'Get help with your Alert1 medical alert system. FAQs, guides, and support resources.',
  },
  '/accessories': {
    title: 'Medical Alert System Accessories - Alert1',
    description: 'Shop Alert1 accessories: replacement bands, lock boxes, medication reminders, and more.',
  },
  '/cart': {
    title: 'Your Shopping Cart - Alert1',
    description: 'Review your Alert1 cart and proceed to checkout.',
  },
  '/checkout': {
    title: 'Secure Checkout - Alert1',
    description: 'Complete your Alert1 medical alert system order securely.',
  },
  '/order-success': {
    title: 'Thank You for Your Order - Alert1',
    description: 'Your Alert1 order has been placed successfully.',
  },
  '/my-account': {
    title: 'My Account - Alert1',
    description: 'Sign in to your Alert1 account to manage your service and settings.',
  },
  '/healthcare-providers': {
    title: 'For Healthcare Providers - Alert1',
    description: 'Alert1 medical alert systems for healthcare providers and senior care facilities.',
  },
  '/current-members': {
    title: 'Member Care Hub - Alert1',
    description: 'Resources and support for current Alert1 members.',
  },
  '/refer-friend': {
    title: 'Refer a Friend - Alert1',
    description: 'Earn one FREE month for you and your friend when they sign up for Alert1.',
  },
  '/where-it-works': {
    title: 'Medical Alert System Range: In-Home or On-the-Go - Alert1',
    description: 'Learn where Alert1 medical alert systems work - in-home, on-the-go, and everywhere in between.',
  },
  '/reviews': {
    title: 'Alert1 Reviews',
    description: 'Read reviews from Alert1 customers. Real feedback on our medical alert systems.',
  },
  '/request-brochure': {
    title: 'Request Your Alert1 Brochure',
    description: 'Request a free Alert1 medical alert system brochure by mail.',
  },
  '/request-admin-access': {
    title: 'Request Admin Access - Alert1',
    description: 'Request admin access to the Alert1 website management system.',
  },
  '/decrypt-orders-report': {
    title: 'Decrypt Orders Report - Alert1',
    description: 'Decrypt the encrypted orders report file using the password from your decryption email.',
  },
  '/forgot-password': {
    title: 'Reset Your Password - Alert1',
    description: 'Reset your Alert1 account password.',
  },
  '/sign-up': {
    title: 'Create Your Account - Alert1',
    description: 'Create your Alert1 account to manage your medical alert service.',
  },
  '/troubleshooting': {
    title: 'Troubleshooting Your Medical Alert System - Alert1',
    description: 'Troubleshooting tips for Alert1 medical alert systems.',
  },
  '/compare': {
    title: 'Alert1 vs Life Alert Cost - Alert1',
    description: 'Compare Alert1 and Life Alert pricing. See how Alert1 offers better value.',
  },
  '/pricing/compare-medical-alert-systems': {
    title: 'Compare Medical Alert Systems - Alert1',
    description: 'Compare medical alert systems and find the right Alert1 plan for you.',
  },
  '/pricing/compare-alert1-to-life-alert': {
    title: 'Alert1 vs Life Alert Cost - Alert1',
    description: 'Compare Alert1 and Life Alert. See how Alert1 offers low-cost alternatives.',
  },
  '/pricing/compare-alert1-to-bay-alarm': {
    title: 'Alert1 vs Bay Alarm Medical - Alert1',
    description: 'Compare Alert1 and Bay Alarm Medical medical alert systems.',
  },
  '/pricing/compare-alert1-to-medical-guardian': {
    title: 'Medical Guardian Alternatives - Try Alert1 - Alert1',
    description: 'Alert1 as an alternative to Medical Guardian medical alert systems.',
  },
  '/pricing/compare-alert1-to-greatcall': {
    title: 'The Perfect GreatCall Alternative - Alert1',
    description: 'Alert1 as the ideal GreatCall alternative for senior safety services.',
  },
  '/pricing/compare-alert1-to-mobilehelp': {
    title: 'Alert1: The Ideal Alternative to MobileHelp - Alert1',
    description: 'Compare Alert1 and MobileHelp medical alert systems.',
  },
  '/pricing/compare-alert1-to-adt-health': {
    title: 'Discover Alert1: The Ideal Alternative to ADT Medical Alert - Alert1',
    description: 'Compare Alert1 and ADT Health medical alert systems.',
  },
  '/why-alert1/first-alert-medical-system': {
    title: 'First Alert Medical System - Alert1',
    description: 'Learn about Alert1 first alert medical system options.',
  },
  '/resources/medicare-medicaid-medical-alert': {
    title: 'Medicare and Medicaid Medical Alert - Alert1',
    description: 'Information about Medicare and Medicaid coverage for medical alert systems.',
  },
  '/resources/senior-cell-phone-reviews-medical-alerts/7125': {
    title: 'Senior Cell Phone Reviews and Medical Alerts - Alert1',
    description: 'Senior cell phone reviews and how they complement medical alert systems.',
  },
  '/resources/medical-alert-system-glossary/209': {
    title: 'Medical Alert System Glossary - Alert1',
    description: 'Glossary of medical alert system terms and definitions.',
  },
  '/resources/baby-boomer-facts-and-statistics/426': {
    title: 'Baby Boomer Facts and Statistics - Alert1',
    description: 'Baby boomer demographic facts and statistics relevant to medical alert adoption.',
  },
  '/content/personal-emergency-response-system/789': {
    title: 'Personal Emergency Response System - Alert1',
    description: 'Learn about personal emergency response systems (PERS) from Alert1.',
  },
  '/life-alert-compared-to-alert1': {
    title: 'Life Alert Compared to Alert1 - Alert1',
    description: 'Compare Life Alert and Alert1 medical alert systems.',
  },
  '/why-alert1/life-alert-alternatives/791': {
    title: 'Life Alert Alternatives - Alert1',
    description: 'Alert1 as a Life Alert alternative. Compare features and pricing.',
  },
  '/products/medical-alert-bracelets/796': {
    title: 'Medical Alert Bracelets - Alert1',
    description: 'Shop Alert1 medical alert bracelets. Stylish, comfortable, and reliable.',
  },
  '/blog/fall-prevention': {
    title: 'Fall Prevention for Aging Parents: A Complete Guide - Alert1',
    description: 'A complete guide to fall prevention for aging parents.',
  },
  '/blog/home-safety': {
    title: 'Rethinking Home Safety for Aging Parents - Alert1',
    description: 'Tips for making home safer for aging parents.',
  },
  '/blog/caregiver-payment': {
    title: 'How Much Do Family Members Get Paid for Caregiving? - Alert1',
    description: 'Complete guide to caregiver stipends and payment programs.',
  },
};
